import { useQuery } from '@tanstack/react-query';
import { fetchCartGroupedItems } from './fetchCartGroupedItems';
import { browserClient } from '../../react-query';
import { GlobalReactQueryOptions } from '../../config';

export const CART_GROUPED_ITEMS_QUERY_KEY = 'cartGroupedItems';

interface Params {
    groupKey: string;
    enabled: boolean;
}
export const useCartGroupedItems = ({ groupKey, enabled }: Params) => {
    return useQuery([CART_GROUPED_ITEMS_QUERY_KEY, groupKey], () => fetchCartGroupedItems(groupKey), {
        ...GlobalReactQueryOptions,
        enabled
    });
};

export const invalidateCartGroupedItems = () => {
    return browserClient.invalidateQueries([CART_GROUPED_ITEMS_QUERY_KEY]);
};
